// components/forms/BasicInfoForm.js
import React from 'react';

function BasicInfoForm({ data, setData }) {
    const handleChange = (field, value) => {
        setData({
            ...data,
            [field]: value
        });
    };

    return (
        <div className="space-y-4">
            <h2 className="text-xl font-bold mb-4">患者基本信息</h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">姓名</label>
                    <input
                        type="text"
                        className="w-full p-2 border rounded"
                        value={data.name}
                        onChange={(e) => handleChange('name', e.target.value)}
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">性别</label>
                    <select
                        className="w-full p-2 border rounded"
                        value={data.gender}
                        onChange={(e) => handleChange('gender', e.target.value)}
                    >
                        <option value="男">男</option>
                        <option value="女">女</option>
                    </select>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">年龄</label>
                    <input
                        type="number"
                        className="w-full p-2 border rounded"
                        value={data.age}
                        onChange={(e) => handleChange('age', e.target.value)}
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">体重 (kg)</label>
                    <input
                        type="number"
                        className="w-full p-2 border rounded"
                        value={data.weight}
                        onChange={(e) => handleChange('weight', e.target.value)}
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">住院号</label>
                    <input
                        type="text"
                        className="w-full p-2 border rounded"
                        value={data.hospitalNumber}
                        onChange={(e) => handleChange('hospitalNumber', e.target.value)}
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">入院时间</label>
                    <input
                        type="datetime-local"
                        className="w-full p-2 border rounded"
                        value={data.admissionTime}
                        onChange={(e) => handleChange('admissionTime', e.target.value)}
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">科室</label>
                    <input
                        type="text"
                        className="w-full p-2 border rounded"
                        value={data.department}
                        onChange={(e) => handleChange('department', e.target.value)}
                    />
                </div>
            </div>
        </div>
    );
}

export default BasicInfoForm;